import { cabinClassNames } from "@/constants/flight/cabinClass"

export const getCabinClassCode = (airportCode: string, cabinClass: string) => {
  switch (airportCode) {
    case "AK": {
      const _cabinClass = (cabinClass || '')[0]
      const cabinName = cabinClassNames.AK[_cabinClass] || ''
      return `${airportCode}${cabinName.toUpperCase().split(/\s+/).join('')}`
    }
    case "QH":
      return `${airportCode}${(cabinClass || '').toUpperCase().split(/\s+/).join('')}`
    case "9G":
      return `${airportCode}${(cabinClass || '').toUpperCase().split(/\s+/).map(str => str.split('').map((c, i) => i === 0 ? c.toUpperCase() : c).join('')).join('')}`.replace('_', '')
    case "VJ":
      return `${airportCode}${(cabinClass || '').toUpperCase().split(/\s+/).join('')}`
    case "VN":
      if ((cabinClass || '') === 'PREMIUM ECONOMY Standard') {
        return `${airportCode}${"Premium Economy Classic".toUpperCase().split(/\s+/).join('')}`
      }
      return `${airportCode}${(cabinClass || '').toUpperCase().split(/\s+/).join('')}`
    case "VU":
      return `${airportCode}${(cabinClass || '').toUpperCase().split(/\s+/).join('')}`
    case "JQ":
      return `${airportCode}${(cabinClass || '').toUpperCase().split(/\s+/).join('')}`
    default:
      break;
  }

  return `${airportCode}${(cabinClass || '')}`
}